<template>
  <div class="section__lk-content container-shadow fill-white">
    <div class="section__lk-title">Мои заявки / Онлайн курсы</div>
    <div class="section__lk-subtitle">Список заявок</div>
    <template v-if="orders">
      <div v-if="!orders.length" class="section__lk-empty">у вас нет активных заявок</div>
      <div v-else class="section__lk-orders">
        <router-link :to="order.program.id === 3 ? '/online' : `/programs/${order.program.id}/order`" v-for="order in orders" :key="order.id" class="section__lk-order">
          <div class="section__lk-order-title">
            <div class="label">Заявка</div>
            {{ order.program.title }}
            <div v-if="getStatusTitle(order)" class="section__lk-order-status-title mt-1">Статус: {{ getStatusTitle(order) }}</div>
          </div>
          <div class="section__lk-order-date-and-status">
            <div class="section__lk-order-date">
              <div class="label">Дата подачи</div>
              {{ order.created_at | formatDate('DD.MM.YYYY') }}
            </div>
            <div class="section__lk-order-status" :title="getStatusTitle(order)"><div :class="'status status_' + order.status"></div></div>
          </div>
      </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import ApiService from "../../../../services/api.service";
import {isHitechProgram} from "@/data/programs";

// Подписи статусов заявки HITECH для слушателя (rejected — это возврат на доработку)
const HITECH_STATUS_TITLES = {
  draft: 'Черновик',
  participant: 'Новая заявка',
  pending: 'Подписание договора',
  approved: 'Одобрено',
  rejected: 'Отправлено на доработку',
  attestation: 'Очная аттестация',
  expired: 'Просрочена',
  complete: 'Обучение завершено'
}

export default {
  name: "OnlineRequests.vue",
  data() {
    return {
      orders: null
    }
  },
  methods: {
    isHitech(order) {
      return Boolean(order.program && isHitechProgram(order.program.id))
    },
    // Подпись статуса (строка «Статус:» и title иконки) только для HITECH. Для остальных программ null:
    // Vue не выводит атрибут title, список заявок как раньше
    getStatusTitle(order) {
      return this.isHitech(order) ? (HITECH_STATUS_TITLES[order.status] || null) : null
    }
  },
  async mounted() {
    this.orders = (await ApiService.get('programparticipants')).data
    if(!this.orders) {
      this.orders = []
    }
  }
}
</script>

<style scoped>
.section__lk-order-status-title {
  color: #828282;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
}
</style>